module.exports = __webpack_public_path__ + "iq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/iq.svg
// module id = 616
// module chunks = 0